import { HeaderFromPage } from "../../components/common/HeaderFormPage";
import { CreatePasswordForm } from "../../components/CreatePasswordForm";
import styles from "./CreatePassword.module.scss";

export const CreatePassword = () => {
  return (
    <div className={styles.wrapper}>
      <HeaderFromPage title='WELKOM' subtitle='Creëer een wachtwoord' />
      <div className={styles.createPassword}>
        <CreatePasswordForm />
      </div>
    </div>
  );
};
